import { render, staticRenderFns } from "./quotations.vue?vue&type=template&id=79445428&scoped=true"
import script from "./quotations.vue?vue&type=script&lang=js"
export * from "./quotations.vue?vue&type=script&lang=js"
import style0 from "./quotations.vue?vue&type=style&index=0&id=79445428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79445428",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/QuotesTracking/quotations.vue
// module id = 2431
// module chunks = 31